import { Injectable } from '@angular/core';
import { SchedulerStageAuthService } from '../../../../views/scheduler-stage/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HosesSchedulerStageAuthService extends SchedulerStageAuthService {
  validateStage(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesLeader ',
      'HosesSupervisor',
      'HosesChief',
      'HosesTrimming',
    ]);
  }
}
